// Helper function to unit test elements in portals
export default () => {
  const modalRoot = document.createElement('div')
  modalRoot.setAttribute('id', 'modal-root')
  const body = document.querySelector('body')
  body!.appendChild(modalRoot)
}
